import { ArticleResult } from 'interface/article'
import { useState, useCallback } from 'react'

export const useArticlePreviewDialog = () => {
	const [articleList, setArticleList] = useState<ArticleResult[]>([])
	const [articleId, setArticleId] = useState<number | null>(null)

	const openArticle = useCallback(
		(articleId: number | null) => {
			setArticleId(articleId)
		},
		[setArticleId]
	)
	const close = useCallback(
		() => openArticle(null),
		[openArticle]
	)
	return {
		articleList,
		articleId,
		setArticleList,
		openArticle,
		close
	}
}